import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Resizable } from 're-resizable';
export const GraphVisualizationSidepanel = ({ sidepanel, }) => {
    const { children, isSidePanelOpen, sidePanelWidth, onSidePanelResize, minWidth = 230, } = sidepanel;
    if (!isSidePanelOpen) {
        return null;
    }
    return (_jsx(Resizable, { defaultSize: {
            height: '100%',
            width: sidePanelWidth !== null && sidePanelWidth !== void 0 ? sidePanelWidth : 400,
        }, className: "ndl-graph-resizable", minWidth: minWidth, maxWidth: "66%", enable: {
            bottom: false,
            bottomLeft: false,
            bottomRight: false,
            left: true,
            right: false,
            top: false,
            topLeft: false,
            topRight: false,
        }, handleClasses: { left: 'ndl-sidepanel-handle' }, onResizeStop: (_e, _dir, ref) => {
            onSidePanelResize(ref.getBoundingClientRect().width);
        }, children: _jsx("div", { className: "ndl-graph-visualization-sidepanel-content", children: children }) }));
};
const Title = ({ children }) => {
    return (_jsx("div", { className: "ndl-graph-visualization-sidepanel-title ndl-grid-area-title", children: children }));
};
GraphVisualizationSidepanel.Title = Title;
const Content = ({ children }) => {
    return _jsx("section", { className: "ndl-grid-area-content", children: children });
};
GraphVisualizationSidepanel.Content = Content;
//# sourceMappingURL=graph-visualization-sidepanel.js.map